import {
  ClientPaymentEntity,
  ClientPaymentStatus,
} from '../types/clientPayments.types';
import { PaginationParams, ResponseType } from '../types/shared.types';
import { WalletReportType } from '../types/wallet.types';
import { api } from './api';

export const findAllPayments = (
  params: PaginationParams<{
    status?: ClientPaymentStatus | null;
    type?: WalletReportType | null;
    query?: string | null;
    from?: string | null;
    to?: string | null;
  }>
) =>
  api.get<ResponseType<ClientPaymentEntity[]>>(`/v1/client-payments`, {
    params,
  });

export const migrateVDrive = () =>
  api.put<ResponseType<null>>(`/v1/client-payments`);

export const migrateCP = () =>
  api.put<ResponseType<null>>(`/v1/client-payments/cp`);

export const retryPayment = (id: string | number) =>
  api.post<ResponseType<ClientPaymentEntity>>(`/v1/client-payments/${id}`);
